module.exports = __webpack_public_path__ + "img/1523751919.03b3d18e.jpg";